import * as actionConsts from './actions';
import update from 'react/lib/update';
import * as dailyReportActionConsts from '../actions';

export const initState = {
  remark: "",
  englishRemark: null
}


export default (state=initState, action) => {
  switch (action.type) {
    case dailyReportActionConsts.DAILY_REPORT_GET_SUCCESS:
      return update(state, {
        remark: {
          $set: action.remark
        },
        englishRemark: {
          $set: action.englishRemark
        }
    });
    case actionConsts.DAILY_REPORT_UPDATE_REMARK:
      return update(state, {
        [action.typeOf]: {
          $set: action.value
        }
    });
    case actionConsts.TRANSLATE_REMARK_TEXT_SUCCESS:
      return update(state, {
        englishRemark: {
          $set: action.value
        }
    });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Remark/reducer.js